import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import MainLayout from '../components/common/MainLayout';
import HomePage from '../pages/HomePage';
import AboutPage from '../pages/AboutPage';
import ProductsPage from '../pages/ProductsPage';
import ContactPage from '../pages/ContactPage';
import BlogsPage from '../pages/BlogsPage';
import BlogDetailPage from '../pages/BlogDetailPage';

import Privacy from '../new components/footer pages/Privacy';
import Terms from '../new components/footer pages/Terms';
import Refund from '../new components/footer pages/Refund';
import TrustSecurity from '../new components/security pages/TrustSecurity';
import LegalityNew from '../new components/security pages/LegalityNew';

const AppRoutesNew = () => {
    const location = useLocation();
    const topRef = useRef(null);

    useEffect(() => {
    window.scrollTo(0, 0);
}, [location.pathname]);

    return (
        <>
            <div ref={topRef} tabIndex="-1" style={{ position: "absolute", top: 0 }} />
            <Routes>
                <Route element={<MainLayout />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/blog" element={<BlogsPage />} />
                    <Route path="/blogs" element={<BlogsPage />} />
                    <Route path="/blog/:slug" element={<BlogDetailPage />} />
                    <Route path="/blogs/:slug" element={<BlogDetailPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    
                    {/* Legal & Security Routes Preserved */}
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms-conditions" element={<Terms />} />
                    <Route path="/refund-policy" element={<Refund />} />
                    <Route path="/trust-security" element={<TrustSecurity />} />
                    <Route path="/e-signature-legality" element={<LegalityNew />} />

                    {/* Catch-all redirect to Home */}
                    <Route path="*" element={<HomePage />} />
                </Route>
            </Routes>
        </>
    );
};

export default AppRoutesNew;
